export default "__VITE_ASSET__C1LZCeFK__"